import {FormattedProperty} from 'common/util/format-property';

export enum EventPropertyToggleChoices {
  ALL_EVENT_PROPERTIES = `All Event Properties`,
  USER_DEFINED_EVENT_PROPERTIES = `Your Properties`,
  MIXPANEL_EVENT_PROPERTIES = `Mixpanel Properties`,
}

export interface ActivityPropertyState {
  selectedToggle: EventPropertyToggleChoices;
}

export interface SplitProperties {
  allProperties: FormattedProperty[];
  userDefinedProperties: FormattedProperty[];
  mixpanelProperties: FormattedProperty[];
}
